import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

export const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Initialize GA4 tracking here when integrated
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-gray-200 shadow-lg z-50 animate-slide-up">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-gray-700">
              We use cookies and analytics to improve your experience and understand how our site is used. 
              By clicking "Accept", you consent to our use of cookies and Google Analytics in accordance with UK GDPR.
              {' '}
              <a href="#privacy" className="text-teal-700 hover:text-teal-800 underline font-medium">
                Privacy Policy
              </a>
            </p>
          </div>
          <div className="flex items-center gap-3">
            <Button
              onClick={handleDecline}
              variant="outline"
              size="sm"
              className="border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Decline
            </Button>
            <Button
              onClick={handleAccept}
              size="sm"
              className="bg-teal-700 hover:bg-teal-800 text-white"
            >
              Accept Cookies
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
